import { render } from "./KomisijePage.vue?vue&type=template&id=2c529df2"
import script from "./KomisijePage.vue?vue&type=script&lang=js"
export * from "./KomisijePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__